import { ReportFilterDateRange } from '@/services/api/resources/analytics-builder/constants';
import { t } from '@/ui/i18n/i18n';

export const useFilterDateDropdown = () => {
  const ranges = [
    {
      type: null,
      text: t('common.all'),
    },
    {
      type: ReportFilterDateRange.today,
      text: t('analytics.today'),
    },
    {
      type: ReportFilterDateRange.yesterday,
      text: t('analytics.yesterday'),
    },
    {
      type: ReportFilterDateRange.lastWeek,
      text: t('analytics.last-week'),
    },
    {
      type: ReportFilterDateRange.lastSevenDays,
      text: t('analytics.last-seven-days'),
    },
    {
      type: ReportFilterDateRange.lastThirtyDays,
      text: t('analytics.last-thirty-days'),
    },
    {
      type: ReportFilterDateRange.lastMonth,
      text: t('analytics.last-month'),
    },
    {
      type: ReportFilterDateRange.custom,
      text: t('analytics.custom'),
    },
  ];

  const findRangeTitle = (type: ReportFilterDateRange | null) => ranges.find(range => range.type === type)?.text;

  return {
    ranges,
    findRangeTitle,
  };
};
